<template>

  <v-card v-if="isAuthenticated">
    <v-card-title>
      <v-flex>
        {{user.first_name}} {{user.last_name}}
      </v-flex>
    </v-card-title>

    <v-card-text>
      <v-flex>
        {{user.email}}
      </v-flex>

      <v-flex>
        {{ selected_project }}
      </v-flex>

      <v-select :items="project_list"
                v-model="selected_project"
                item-text="name" item-value="id"
                outlined dense>
      </v-select>

    </v-card-text>

    <v-card-actions>
      <v-tooltip right>
        <template #activator="{ on }">
          <v-btn icon v-on="on"
                 @click="$emit('close')">
            <v-icon>mdi-close-outline</v-icon>
          </v-btn>
        </template>
        <template #default>
          <span>Close</span>
        </template>
      </v-tooltip>

      <v-spacer></v-spacer>

      <v-btn to="/logout" id="btnLogout" :disabled="!isAuthenticated">
        Logout
      </v-btn>
    </v-card-actions>

  </v-card>

</template>

<script>

	import format from 'string-format'

	import {
		VCard, VBtn
	} from 'vuetify'

	import {mapGetters, mapActions} from 'vuex'

	export default {
		name: 'user-card',

		components: {
			VCard, VBtn
		},

		data: function () {
			return {
				selected_project: -1, // current project id
				// user: {
				// 	firstname: null,
				// 	lastname: null,
				// 	email: null,
				// }
			}
		},

		watch: {
			selected_project: function (new_value, old_value) {
				this.project_set_selected(new_value)
			},

			project_selected: function (new_value, old_value) {
				this.selected_project = new_value
			}
		},

		computed: {
			...mapGetters({
				isAuthenticated: 'auth/isAuthenticated',
				user: 'auth/user',
				project_list: 'lists/project_list',
				project_selected: 'project/selected',
			}),

		},

		mounted: function () {
			this.selected_project = this.project_selected
		},

		methods: {
			...mapActions({
				project_set_selected: 'project/set_selected'
			}),

		}
	}
</script>

<style scoped>

</style>